import React from "react";
import { ShieldCheck } from "lucide-react";

/** Small fixed corner widget shown throughout a proctored interview — visible webcam preview
 * (so the candidate always knows they're on camera) + live violation counter. */
export default function ProctoringStatusBar({ webcamVideoRef, violationCount, violationLimit }) {
  return (
    <div className="fixed top-20 right-4 z-50 flex items-start gap-2" data-testid="proctoring-status-bar">
      <div className="glass-panel rounded-xl px-3 py-1.5 flex items-center gap-2 mb-1">
        <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" />
        <span className="text-[11px] font-semibold text-slate-300">Proctoring Active</span>
        <span
          className={`text-[11px] font-bold px-1.5 py-0.5 rounded-full ${violationCount > 0 ? "bg-rose-400/20 text-rose-300" : "bg-emerald-400/15 text-emerald-300"}`}
          data-testid="proctoring-violation-count"
        >
          {violationCount}/{violationLimit}
        </span>
      </div>
      <video
        ref={webcamVideoRef}
        autoPlay
        muted
        playsInline
        data-testid="proctoring-webcam-preview"
        className="w-24 h-20 rounded-lg border border-white/15 object-cover bg-black shadow-lg"
      />
    </div>
  );
}
